export const questions = [
  {
    code: "improve",
    question: "Does it impact safety and efficacy of the device?",
  },
  { code: "label", question: "Is this labelling related change?" },
  {
    code: "technology",
    question: "Is this technology or engineering related change?",
  },
  { code: "material", question: "Is this material related change?" },
  {
    code: "A1",
    question: "Is it a change in the indications for use statements",
  },
  {
    code: "A11",
    question:
      "Is it a change from a device labeled for single use only to a device labeled as reusable?",
  },
  {
    code: "A12",
    question: "Is it a change from Rx to over the counter OTC use?",
  },
  {
    code: "A13",
    question:
      "Is it a change to the device name or to solely improve readability or clarity?",
  },
  {
    code: "A14",
    question:
      "Does the change describe a new disease, condition the device is intended in diagnosing, treating, preventing, curing or mitigating?",
  },
  {
    code: "A15",
    question:
      "Does a risk-based assessment identify any new risks or significantly modified existing risks",
  },
  {
    code: "A2",
    question: "Does the change add or delete a contraindication?",
  },
  {
    code: "A3",
    question: "Is it a change in the warnings or precautions?",
  },
  { code: "A4", question: "Could it affect the directions for use?" },
  { code: "B1", question: "Is the device an IVD?", onlyNegative: true },
  {
    code: "B2",
    question:
      "Is it a control mechanism, operating principle, or energy type change?",
  },
  {
    code: "B3",
    question: "Is it a change in sterilization, cleaning, or disinfection ? ",
  },
  {
    code: "B31",
    question:
      "Is it a change to a Cat. Bor novel method, does it lower the SAL, or is it a change to how the device is provided?",
  },
  {
    code: "B32",
    question:
      "Could the change significantly affect performance/ biocompatibility?",
  },
  {
    code: "B4",
    question: "Is there a change in packaging or expiration dating?",
  },
  {
    code: "B41",
    question:
      "Is the same method or protocol, described in previous 510(k), used to support change?",
  },
  {
    code: "B5",
    question:
      "Is it any other change in design (e.g., dimensions, performance specifications, communications, accessories, patient/user interface)?",
  },
  {
    code: "B51",
    question: "Does the change significantly affect the use of the device?",
  },
  {
    code: "B52",
    question:
      "Does a risk assessment identify any new or significantly modified risks?",
  },
  { code: "B53", question: "Is clinical data necessary?" },
  { code: "B54", question: "Any unexpected issues from V&V activities?" },
  { code: "C1", question: "Is the device an IVD?", onlyNegative: true },
  {
    code: "C2",
    question:
      "Change in material type, formulation, chemical composition, or the material's processing?",
  },
  {
    code: "C3",
    question:
      "Will the changed material directly or indirectly contact body tissues or fluids?",
  },
  {
    code: "C4",
    question:
      "Does a risk assessment identify any new or increased biocompatibility concerns?",
  },
  {
    code: "C41",
    question:
      "Has the manufacturer used the same material in a similar legally marketed device(formulation, processing, type/duration of contact,etc.)?",
  },
  {
    code: "C5",
    question: "Could the change affect performance specifications?",
  },
  { code: "New510", question: "New 510(k)", lastState: true },
  { code: "Document", question: "Documentation", lastState: true },
];

export function pickRandomQuestion() {
  let result;
  let count = 0;
  for (const prop in questions)
    if (Math.random() < 1 / ++count) result = questions[prop];
  return result;
}
